/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ address: NonNullable<unknown> }} Addr_Sugg_MatchedInputs */

const cs_addr_sugg_matched = /** @type {(inputs: Addr_Sugg_MatchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Shoda v RÚIAN: ${i?.address}`)
};

const en_addr_sugg_matched = /** @type {(inputs: Addr_Sugg_MatchedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`RÚIAN match: ${i?.address}`)
};

/**
* | output |
* | --- |
* | "RÚIAN match: {address}" |
*
* @param {Addr_Sugg_MatchedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const addr_sugg_matched = /** @type {((inputs: Addr_Sugg_MatchedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Addr_Sugg_MatchedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_addr_sugg_matched(inputs)
	return cs_addr_sugg_matched(inputs)
});